module.exports = __webpack_public_path__ + "static/pid-ug-15-en-authenticated-bffefbe2432b8b070fb528e3cc1cc04c.png";